import {ErrorDtoFactory, UserAndPermissionDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as UsersAndPermissionActions} from "../actions/usersAndPermissionsActions";
import {ActionType} from "../actionTypes";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";

export const getUsersAndPermissions = () => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<UsersAndPermissionActions>) => {
        dispatch({
            type: ActionType.GET_USERS_AND_PERMISSIONS_DATA_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/AccountUsers/GetAccountUsers`;
            let result = await axios.get(url, config);
            let data = result.data.data
            dispatch({
                type: ActionType.GET_USERS_AND_PERMISSIONS_DATA_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.GET_USERS_AND_PERMISSIONS_DATA_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.GET_USERS_AND_PERMISSIONS_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}

export const deleteUserFromAccount = (ids: number[], users: UserAndPermissionDto[]) => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<UsersAndPermissionActions>) => {
        dispatch({
            type: ActionType.DELETE_USER_AND_PERMISSIONS_DATA_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/AccountUsers/DeleteAccountUsers`;
            let result = await axios.post(url, ids, config);
            const usersDataAfterDelete = users.filter((user) => user.acuRecId !== ids[0]);
            dispatch({
                type: ActionType.DELETE_USER_AND_PERMISSIONS_DATA_SUCCESS,
                payload: usersDataAfterDelete
            })
            dispatch({
                type: ActionType.DELETE_USER_AND_PERMISSIONS_DATA_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_USER_AND_PERMISSIONS_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}

export const saveUserFromAccount = (userAndPermissionData: UserAndPermissionDto, users: UserAndPermissionDto[]) => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<UsersAndPermissionActions>) => {
        dispatch({
            type: ActionType.SAVE_USER_AND_PERMISSIONS_DATA_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/AccountUsers/${userAndPermissionData.acuRecId ? "UpdateAccountUsers" : "CreateAccountUsers"}`;
            // const requestBody = {
            //     ...userAndPermissionData,
            //     acuPassword: userAndPermissionData.acuPassword || "123456"
            // }
            let result = await axios.post(url, [userAndPermissionData], config);
            const createdUsers = result.data.data;
            let usersAfterDelete: UserAndPermissionDto[] = [];
            let usersWithNewUsers: UserAndPermissionDto[] = [];
            if(!userAndPermissionData.acuRecId){
                usersWithNewUsers = [...createdUsers, ...users];
            } else {
                usersAfterDelete = users.filter((user: UserAndPermissionDto) => user.acuRecId !== userAndPermissionData.acuRecId);
                usersWithNewUsers = [userAndPermissionData, ...usersAfterDelete];
            }
            dispatch({
                type: ActionType.SAVE_USER_AND_PERMISSIONS_DATA_SUCCESS,
                payload: usersWithNewUsers
            })
            dispatch({
                type: ActionType.SAVE_USER_AND_PERMISSIONS_DATA_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.SAVE_USER_AND_PERMISSIONS_DATA_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}

export const updateUsersData = (users: UserAndPermissionDto[]) => {
    return async (dispatch: Dispatch<UsersAndPermissionActions>) => {
        dispatch({
            type: ActionType.UPDATE_USER_AND_PERMISSIONS_DATA,
            payload: users
        });
    }

}

